export default "__VITE_ASSET__CZeATDD0__"